export default class LaboratoryAnalyseDto {
    constructor(analyseData) {
        this.analysisId = analyseData?.analysisId;
        this.price = analyseData?.price;
        this.delayInDays = analyseData?.delayInDays;
        this.quantityInGram = analyseData?.quantityInGram;
        this.reference = analyseData?.reference;
    }
}